import styled from 'styled-components';

export const FunnelAddressContainer = styled.div`
    .error-message {
        color: ${props => props.theme.error};
        margin-top: 20px;

        a {
            color: ${props => props.theme.error};
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/funnel/address-step/FunnelAddressStepStyle.js